import { Component, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-arr-smart',
  templateUrl: './arr-smart.component.html',
  styleUrls: ['./arr-smart.component.scss']
})
export class ArrSmartComponent extends BaseComponent {
  @Output() addSmartGroup = new EventEmitter<string>();

  @Output() removeSmartGroup = new EventEmitter<{ name: string, index: number }>();

  addSmartFormGroup(name: string): void {
    this.addSmartGroup.emit(name);
  }

  removeSmartFormGroup(name: string, index: number): void {
    this.removeSmartGroup.emit({name, index})
  }
}
